export const REGEX_VALIDATE_MAIL = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const MaximumNumberBeforeCompactNotation = 999999999;